import { useEffect, useMemo, useState } from "react";

export function useMediaQuery(query: string) {
  const getMatches = useMemo(
    () => () =>
      typeof window !== "undefined" ? window.matchMedia(query).matches : false,
    [query],
  );

  const [matches, setMatches] = useState<boolean>(getMatches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const handler = () => setMatches(media.matches);
    handler();
    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", handler);
      return () => media.removeEventListener("change", handler);
    }
    (media as unknown as { addListener: (cb: () => void) => void }).addListener(
      handler,
    );
    return () =>
      (
        media as unknown as { removeListener: (cb: () => void) => void }
      ).removeListener(handler);
  }, [query]);

  return matches;
}

export function useIsMobile() {
  return useMediaQuery("(max-width: 639px)");
}
